import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'HomeServices-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
